import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

// 账户相关
const publisher = new Restful(project, 'publisher')

publisher.webGet = function(id) {
  const url = project + 'publisher/website/' + id
  return http.get(url).then(res => {
    return res
  })
}
publisher.emailBlackList = function(id, data) {
  const url = project + `publisher/${id}/email_list`
  return http.put(url, data).then(res => {
    return res
  })
}
export default publisher
